import type {Analytics,Content,ContentList} from '../../lib/types';
import {api} from '../../lib/api';
import {articleLocaleOrder} from './articleLocaleOrder';
type Group=Analytics['groups'][number];
export async function loadArticleIndex():Promise<Content[]>{
 const items:Content[]=[],seen=new Set<string>();let cursor:string|undefined;
 do{
  const page=await api<ContentList>('listContent',{filter:{kinds:['article']},groupTranslations:true,limit:100,...(cursor?{cursor}:{})});
  items.push(...page.items);cursor=page.nextCursor;
  if(cursor&&seen.has(cursor))throw new Error('Artiklernes sprogpar kunne ikke hentes');
  if(cursor)seen.add(cursor);
 }while(cursor);
 return items;
}
export function groupArticleResults(groups:Group[],articles:Content[]){
 const relations=new Map<string,string>();
 for(const article of articles){
  const key=[article.source,article.resourceId,article.translationGroupId||article.id].join(':');
  for(const id of article.articleIds||[article.articleId||article.id])relations.set(id,key);
 }
 const result:{key:string;groups:Group[]}[]=[],byKey=new Map<string,{key:string;groups:Group[]}>();
 for(const group of groups){
  const relation=group.href?.startsWith('/knowledge/')?relations.get(group.itemId||group.key):undefined;
  const key=relation?'article:'+relation:'result:'+group.key;
  let entry=byKey.get(key);
  if(!entry){entry={key,groups:[]};result.push(entry);byKey.set(key,entry);}
  entry.groups.push(group);
 }
 for(const entry of result)entry.groups.sort(articleLocaleOrder);
 return result;
}
